import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { get } from 'lodash';


@Injectable()
export class GroupingService {

  constructor() { }


  private globalGroup = new Map();

  private mapToObject(map) {
    const out = Object.create(null);
    map.forEach((value, key) => {
      if (value instanceof Map) {
        out[key] = this.mapToObject(value);
      }
      else {
        out[key] = value;
      }
    });
    return out;
  }

  private getGrouppedDataForConcepts(data: any[], groupId: any) {

    let  innerDatas: any[] = [];
    const currentMap = new Map<string, any[]> ();
    data.forEach(function(value) {
      let curreentKey = value[groupId];
      if (typeof curreentKey == 'object') {
        curreentKey = get(curreentKey, 'code');
      }
      if (currentMap.has(curreentKey)) {
        innerDatas = currentMap.get(curreentKey);
      } else {
        innerDatas = [];
      }
      innerDatas.push(value);
      currentMap.set(curreentKey, innerDatas);

    });
    return currentMap;

  }

  private updateLeafNodes(groupId: string, groupMap: Map<string, any>) {
    groupMap.forEach((value: any, key: string) => {

      const valueIsMap: boolean = value instanceof Map;
      if (valueIsMap) {
        this.updateLeafNodes(groupId, value);
      } else {
        const currentMap = this.getGrouppedDataForConcepts(value, groupId);
        groupMap.set(key, currentMap);
      }
    });
  }

  getGrouppedData(data: any[], groupIds: string[]) {
    this.globalGroup = new Map();
    groupIds.forEach((groupId: string, index: number) => {

      if (this.globalGroup.size === 0) {
        const currentMap = this.getGrouppedDataForConcepts(data, groupId);
        this.globalGroup = currentMap;
      } else {
        this.updateLeafNodes(groupId, this.globalGroup);
      }

    });
    const currentJSONObject: any = this.mapToObject(this.globalGroup);
    // let jsonString = JSON.stringify(currentJSONObject);
    return currentJSONObject;
  }

  getGrouppedDataObservable(data: any[], groupIds: string[]): Observable<string> {
    // return new Observable(this.getGrouppedData(data, groupIds));
    const simpleObservable = new Observable<string>((observer) => {
      const jsonValue = this.getGrouppedData(data, groupIds);
      observer.next(jsonValue);
      observer.complete();
    });

    return simpleObservable;
  }

}
